import axios from 'axios';

export const axiosAPI = axios.create({
    baseURL: process.env.REACT_SERVER_BASE_URL,
})

// Intercept responses in order to log any errors to the console.
axios.interceptors.response.use(function (response) {
    return response;
}, function (err) {
    console.error(err)
    return err;
});

// Returns a nice string by reading the axios error.
export function parseAxiosError(err: any): string {
    if (!err.isAxiosError) {
        return err + '';
    }

    let message = err?.response?.data;
    if (!message) message = err?.response;
    if (!message) message = 'No server response. Are you connected to VPN? - ' + err;
    return message + '';
}